import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export const getProjects = (params = {}) => api.get("/projects", { params }).then((r) => r.data);
export const getProject = (slug) => api.get(`/projects/${slug}`).then((r) => r.data);
export const getServices = () => api.get("/services").then((r) => r.data);
export const postEnquiry = (formData) =>
  api.post("/enquiries", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);

export default api;
